// extracted by mini-css-extract-plugin
export default {"backdrop":"modals_backdrop__o2hH9","modal":"modals_modal__rYOpe","popup":"modals_popup__VGsvN"};